<template>
    <button @click="openModal" class="learn-modal__button learn-modal__button--open">
        <img src="@/assets/images/bulb.svg" :alt="$t('game.learn-more')" />
    </button>

    <div v-if="tooltipsLearnMoreActive && tooltipsSeenAll" class="tooltip tooltip--small animate__animated animate__bounceInRight">
        <div class="tooltip__text">{{ $t('game.tooltip.learn-more') }}</div>
    </div>

    <div v-if="isModalOpen" class="learn-modal">
        <div class="learn-modal__container animate__animated animate__bounceInUp">
            <button @click="closeModal" class="learn-modal__button learn-modal__button--close">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.196 17.1952L24.4783 17.2032C24.7976 17.2032 25.1038 17.0763 25.3296 16.8505C25.5554 16.6248 25.6822 16.3186 25.6822 15.9993C25.6823 15.68 25.5555 15.3738 25.3297 15.1481C25.104 14.9223 24.7978 14.7955 24.4785 14.7955L17.1962 14.8045L17.2052 7.5222C17.2052 7.20292 17.0784 6.89673 16.8526 6.67098C16.6269 6.44524 16.3207 6.31843 16.0014 6.31845C15.6821 6.31847 15.3759 6.44533 15.1501 6.6711C14.9244 6.89688 14.7975 7.20309 14.7975 7.52237L14.8055 14.8047L7.52312 14.7967C7.36485 14.7961 7.20801 14.8268 7.06166 14.8871C6.9153 14.9474 6.78233 15.036 6.67041 15.148C6.55848 15.2599 6.46983 15.3928 6.40955 15.5392C6.34927 15.6856 6.31856 15.8424 6.3192 16.0007C6.31854 16.1589 6.34922 16.3158 6.40948 16.4621C6.46974 16.6085 6.55838 16.7414 6.67029 16.8533C6.78219 16.9652 6.91515 17.0539 7.0615 17.1141C7.20784 17.1744 7.36468 17.2051 7.52295 17.2044L14.8053 17.1954L14.7963 24.4778C14.7956 24.636 14.8263 24.7929 14.8866 24.9392C14.9468 25.0855 15.0355 25.2185 15.1474 25.3304C15.2593 25.4423 15.3922 25.531 15.5386 25.5912C15.6849 25.6515 15.8418 25.6822 16 25.6815C16.1583 25.6821 16.3151 25.6514 16.4615 25.5912C16.6078 25.5309 16.7408 25.4422 16.8527 25.3303C16.9647 25.2184 17.0533 25.0854 17.1136 24.939C17.1739 24.7927 17.2046 24.6359 17.204 24.4776L17.196 17.1952Z" fill="#A9A9B9"/>
                </svg>
            </button>

            <div class="learn-modal__info">
                <div class="learn-modal__title">{{ $t('game.learn-more.title')}}</div>
                <img src="@/assets/images/sparkle.svg" :alt="$t('game.learn-more')" />
            </div>

            <vueper-slides :infinite="false" :disableArrowsOnEdges="true" class="no-shadow">
                <vueper-slide v-for="(tooltip, index) in tooltips" :key="index" :content="tooltip.tooltip" />

                <template #arrow-right>
                    <div class="btn btn--primary">{{ $t('button.next') }}</div>
                </template>
                <template #arrow-left>
                    <div class="btn">{{ $t('button.back') }}</div>
                </template>
            </vueper-slides>
        </div>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
    name: 'LearnMore',
    components: {
        VueperSlides,
        VueperSlide
    },
    props: ['tooltips'],
    data() {
        return {
            isModalOpen: false
        }
    },
    computed: {
        tooltipsSeenAll() {
            return this.$store.getters['game/getTooltipsSeenAll'];
        },
        tooltipsLearnMoreActive() {
            return this.$store.getters['game/getTooltipsLearnMore'];
        }
    },
    methods: {
        openModal() {
            this.isModalOpen = true;
            document.body.classList.add('no-scroll');
            this.$store.commit('game/updateLearnMoreTooltip');
        },
        closeModal() {
            this.isModalOpen = false;
            document.body.classList.remove('no-scroll');
        }
    }
}
</script>
